export default __webpack_public_path__ + "static/media/fraseES.815655ad.png";